import moment from "moment";

export const filtrosDefault = {
  dataInicio: moment()
    .startOf("month")
    .format("YYYY-MM-DD"),
  dataFim: moment()
    .endOf("month")
    .format("YYYY-MM-DD"),
  situacoes: ["AGENDADO"],
  profissionalSaude: null,
};

export const situacoesOptionsDefault = [
  {
    nome: "Todas as situações",
    value: "TODAS_SITUACOES",
    checked: false,
  },
  {
    nome: "Agendado",
    value: "AGENDADO",
    checked: true,
  },
  {
    nome: "Aguardando",
    value: "AGUARDANDO",
    checked: false,
  },
  {
    nome: "Cancelado",
    value: "CANCELADO",
    checked: false,
  },
  {
    nome: "Excluído",
    value: "EXCLUIDO",
    checked: false,
  },
  {
    nome: "Confirmado",
    value: "CONFIRMADO",
    checked: false,
  },
  {
    nome: "Atendido",
    value: "ATENDIDO",
    checked: false,
  },
   {
    nome: "Atendendo",
    value: "ATENDENDO",
    checked: false,
  },
];

export const columns = [
  {
    Header: "Profissional",
    align: "left",
    getValue: (data) => {
      return data.nomeProfissional;
    },
    field: "profissionalSaude",
  },
  {
    Header: "Situação do agendamento",
    align: "left",
    getValue: (data) => {
      return data.situacao;
    },
    field: "situacao",
  },
  {
    Header: "Quantidade",
    align: "left",
    getValue: (data) => {
      return data.quantidade;
    },
    field: "quantidade",
  },
];
